import {
  checkoutApplePayPayment,
  validateApplePaySession,
  validateShippingContact,
} from 'routes/Checkout/checkoutActions'
import { CheckoutStore } from 'routes/Checkout/models/CheckoutStore'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'
import {
  createApplePaySession,
  createSignupRequest,
} from 'routes/Checkout/utils/applePaySessionUtils'
import { Pricing } from 'routes/Menu/domains/pricing'

/**
 * Creates and starts Apple Pay payment session.
 * @param pricing - checkout pricing info (total price, etc.).
 * @param deliveryDate - user selected date
 * @param deliveryTime - user selected time range
 */
export const initApplePaySession: CheckoutActionCreator =
  (pricing: Pricing | null, deliveryDate: string, deliveryTime: string) => (dispatch, getState) => {
    const state = getState() as unknown as CheckoutStore
    if (pricing === null) return

    const signupRequest = createSignupRequest(state, pricing, deliveryDate, deliveryTime)
    if (signupRequest === null) return

    const session = createApplePaySession(signupRequest, {
      onvalidatemerchant: (event) => dispatch(validateApplePaySession(event, session)),
      onpaymentauthorized: (event) => dispatch(checkoutApplePayPayment(event, session, pricing)),
      onshippingcontactselected: (event) => {
        const errors = dispatch(validateShippingContact(event.shippingContact))
        session.completeShippingContactSelection({
          newTotal: {
            type: 'final',
            label: 'Total',
            amount: pricing.total as string,
          },
          errors,
        })
      },
    })
  }
